import application from 'application';
import internalEventCodes from 'event-system/codes/internal';

export function notifyRefused() {
  application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
    message: 'These blocks could not be added inside this layout.',
    seconds: 5,
    type: 'error'
  });
}
